module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_2.dddb5d6d.png";